'use client';

import { memo } from 'react';

export const WorkspaceLoadingState = memo(() => (
  <main className="flex h-screen flex-col items-center justify-center bg-white dark:bg-neutral-1">
    {/* <output> carries an implicit role="status" + aria-live="polite", so
        screen readers announce the loading state as it appears. */}
    <output aria-live="polite" className="flex flex-col items-center gap-3">
      <div aria-hidden="true" className="size-8 animate-spin rounded-full border-2 border-neutral-6 border-t-brand-9" />
      <p className="text-14 text-neutral-10">Loading your workspace...</p>
    </output>
  </main>
));

WorkspaceLoadingState.displayName = 'WorkspaceLoadingState';
